import { m, AnimatePresence, LazyMotion, domAnimation } from "framer-motion"
import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import { StructuredText } from "react-datocms"

import Heading from "../../../utils/OptimizedHeading"
import Img from "../../../utils/OptimizedImage"
import screenResponsive from "../../../utils/screenResponsive"
import Icon from "../../Icon/Icon"
import { Button } from "../styles/SlideBox.styled"
import { VariantSlideWrap } from "../styles/SlideVariant.styled"

import SlideBoxAccordion from "./SlideBoxAccordion"

const SlideVariant = ({
  component,
  grid,
  bgClass,
  cardVariants,
  handleSwitcher,
  activeSlideIndex,
}) => {
  const isMobile = screenResponsive(576)

  const headingSize = component?.headingSize?.replace(/\s/g, "-").toLowerCase()

  return isMobile ? (
    <SlideBoxAccordion
      component={component}
      headingSize={headingSize}
      bgClass={bgClass}
    />
  ) : (
    <VariantSlideWrap
      className={`bg-${bgClass} container-${
        grid !== "" ? grid?.toLowerCase() : "normal"
      } ${component?.floatabove ? "floatabove" : ""} ${
        component?.bottomPadding ? "bottom-padding" : ""
      } ${component?.topPadding ? "top-padding" : ""}`}
    >
      <Container>
        <Row>
          <Col>
            <div className="heading-container mb-5">
              {component?.eyebrow && (
                <p className="heading-kicker eyebrow">{component?.eyebrow}</p>
              )}
              {component?.heading && (
                <h2 className={`heading ${headingSize}`}>
                  {component?.heading}
                </h2>
              )}
              {component?.slideBoxBody && (
                <div className="description">
                  <StructuredText
                    data={component?.slideBoxBody}
                    renderInlineRecord={() => {}}
                  />
                </div>
              )}
            </div>
            <div className="main-container horizontal-tabs">
              <div className="tabs-area">
                {component?.variantSlides &&
                  component?.variantSlides.map((item, index) => (
                    <Button
                      key={index}
                      className={
                        activeSlideIndex === index ? "active-button" : ""
                      }
                      onClick={() => handleSwitcher(index)}
                    >
                      {item?.iconSelect && (
                        <Icon
                          id={item?.iconSelect}
                          active={activeSlideIndex === index}
                          size={40}
                          theme="grayBlue"
                          classes={activeSlideIndex === index && `active`}
                        />
                      )}
                      {item?.navLabel}
                    </Button>
                  ))}
              </div>
              <AnimatePresence mode="wait" initial={true}>
                <LazyMotion features={domAnimation}>
                  <m.div
                    key={activeSlideIndex}
                    variants={cardVariants}
                    initial="enter"
                    animate="center"
                    exit="exit"
                    transition={{ duration: 0.3 }}
                  >
                    {component?.variantSlides &&
                      component?.variantSlides.map((item, id) => (
                        <div
                          key={id}
                          className={
                            id === activeSlideIndex
                              ? "active-slide"
                              : "inactive"
                          }
                        >
                          <Row className="slide-desc">
                            <Col lg={6} md={12} className="slide-text">
                              {item?.heading && (
                                <Heading
                                  type={item?.headingSize}
                                  string={item?.heading}
                                  className="heading"
                                />
                              )}
                              {item?.eyebrow && (
                                <div className="slide-eyebrow">
                                  {item.eyebrow}
                                </div>
                              )}
                              {item?.heading && (
                                <div className="slide-heading">
                                  {item.heading}
                                </div>
                              )}
                              {item?.subhead && (
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item?.subhead,
                                  }}
                                  className="slide-subhead"
                                />
                              )}
                            </Col>
                            <Col
                              lg={6}
                              md={12}
                              className="d-flex align-items-center text-center"
                            >
                              {item?.image && (
                                <div
                                  style={{
                                    maxWidth:
                                      item?.reference?.desktop?.width + "px",
                                    margin: "0 auto",
                                  }}
                                >
                                  <Img
                                    src={item?.image?.url}
                                    alt={item?.image?.alt || item?.heading}
                                    image={item?.image?.gatsbyImageData}
                                    fadeIn={false}
                                    loading="eager"
                                    className="slideImg"
                                  />
                                </div>
                              )}
                            </Col>
                          </Row>
                        </div>
                      ))}
                  </m.div>
                </LazyMotion>
              </AnimatePresence>
            </div>
          </Col>
        </Row>
      </Container>
    </VariantSlideWrap>
  )
}

export default SlideVariant
